import React from 'react';
import { update_window_type } from '../../../../../redux/Slice/windowTypeSlice';
import { useDispatch } from 'react-redux';
import usePreviewResize from '../../../../../Hooks/usePreviewResize';
import { enterPreviewMode } from '../../../../../utils/preview/enterPreviewMode';
import { exitPreviewMode } from '../../../../../utils/preview/exitPreviewMode';

const TabContainer = ({
  windowTabs,
  window_type,
  store: _store,
  objectt,
  scene,
  startAllAnimations,
}) => {
  const dispatch = useDispatch();
  const currentScene = scene || objectt?.scene;

  const { handleReplay } = usePreviewResize({
    completeObject: objectt,
  });

  const handleTabClick = (tab) => {
    if (tab.type === 'code' || tab.type === window_type) return;

    if (tab.type === 'preview') {
      enterPreviewMode({
        dispatch,
        scene: currentScene,
        currentWindowType: window_type,
        completeObject: objectt,
        handleReplay,
        startAllAnimations,
      });
      return;
    }

    if (tab.type === 'design' && window_type === 'preview') {
      exitPreviewMode({
        dispatch,
        scene: currentScene,
        currentWindowType: window_type,
      });
      return;
    }

    dispatch(
      update_window_type({
        type: tab.type,
        current_type: window_type,
        scene: currentScene,
      })
    );
  };

  return (
    <div className="tab-container">
      {windowTabs.map((tab) => (
        <button
          key={tab.type}
          onClick={() => handleTabClick(tab)}
          className={`tab-btn ${window_type === tab.type ? 'active' : ''} ${tab.type === 'code' ? 'cursor-not-allowed opacity-60' : ''}`}
        >
          <img
            className="tab-btn-icon"
            src={tab.icon}
            alt={`${tab.label} Icon`}
          />
          <span>{tab.label}</span>
        </button>
      ))}
    </div>
  );
};

export default TabContainer;
